export const ACTION_CREATED = 1;
export const ACTION_UPDATED = 2;
export const ACTION_STATUS_CHANGED = 3;
export const ACTION_BULK_UPDATED = 4;
export const ACTION_ROLLED_BACK = 5;
export const ACTION_IMPORTED = 6;
export const ACTION_AUTO_FIX = 7;
